import React, { createContext, useContext, useState } from "react";

const PatientModalContext = createContext();

export const usePatientModal = () => useContext(PatientModalContext);

export const PatientModalProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [selectedPatientId, setSelectedPatientId] = useState(null);

  const showModal = (id) => {
    setSelectedPatientId(id);
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
    setSelectedPatientId(null);
  };

  return (
    <PatientModalContext.Provider value={{ open, selectedPatientId, showModal, closeModal }}>
      {children}
    </PatientModalContext.Provider>
  );
};
